import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';

var Check = function Check(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: "16",
    height: "16",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "data-icontype": "Check"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7206 4.65576C13.1211 5.09851 13.087 5.78216 12.6442 6.18273L6.96856 11.3179C6.56187 11.6858 5.9441 11.6909 5.53136 11.3298L3.3692 9.4379C2.91986 9.04474 2.87433 8.36175 3.2675 7.91241C3.66067 7.46308 4.34365 7.41755 4.79299 7.81072L6.23123 9.06918L11.1936 4.57942C11.6363 4.17884 12.32 4.21302 12.7206 4.65576Z"
  }));
};

var Check$1 = Check;

export { Check$1 as default };
